import { computed } from 'vue'

import { useRetained } from '@/composables/useRetained'
import { statusOf } from '@/lib/strategy/plan'
import { useContentStore } from '@/stores/content'
import { isLoaded } from '@/types/load-state'
import type { ArticleDoc } from '@/types/content'
import type { Page, PageStatus } from '@/types/plan'

/** The brand's articles and the status they give a planned page; holds the content feeds while the caller lives. */
export function usePageStatus() {
  const content = useContentStore()
  useRetained(content.retain)
  const articles = computed<ArticleDoc[]>(() =>
    isLoaded(content.articles) ? content.articles.value : [],
  )
  return {
    articles,
    statusOf: (page: Pick<Page, 'id' | 'existing'>): PageStatus => statusOf(page, articles.value),
  }
}
